import React from "react";
import AlphaherdNftCard from "../../component/shared/card/alphaherd.nftCard";
import AlphaherdSectionContentCard from "../../component/shared/card/alphaherd.sectionContentCard";
import { islandDropsData } from "./data";

const AlphaherdIslandDropsSection = () => {
  return (
    <section className="alpha_islandDrops_section">
      <div className="container">
        <div className="section_wrapper">
          {islandDropsData.map((d) => (
            <>
              <div className="row">
                <div className="col-md-12 section_content">
                  <AlphaherdSectionContentCard
                    subTitle={d.subTitle}
                    title={d.title}
                    description={d.description}
                  />
                </div>
              </div>
              <div className="nft_image_box">
                <div className="row">
                  {d.images.map((img, i) => (
                    <div className="col-md-4">
                      <AlphaherdNftCard
                      key={(i + 1)}
                      animDir="fade-up"
                      animDelay={`${i + 5}00`}
                      img={img.img}
                      text={img.text}
                      nftContent={true}
                    />
                    </div>
                  ))}
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AlphaherdIslandDropsSection;
